"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_paper_1 = require("react-native-paper");
const react_native_1 = require("react-native");
const buttonStyles_1 = __importDefault(require("./buttonStyles"));
const icon_1 = __importDefault(require("../icon/icon"));
const colors_1 = __importDefault(require("../../styles/colors"));
const styles_1 = __importDefault(require("../../styles/styles"));
const pressable_1 = __importDefault(require("../pressable/pressable"));
const DefaultProps = {
    fill: false,
    icon: undefined,
    disabled: false,
};
const Button = ({ text, icon, fill, disabled, onPress, eventName }) => {
    let color;
    let backgroundStyle;
    // Set background style of button based on the type of button
    if (fill && disabled) {
        color = colors_1.default.WHITE;
        backgroundStyle = buttonStyles_1.default.disabledFilled;
    }
    else if (fill && !disabled) {
        color = colors_1.default.WHITE;
        backgroundStyle = buttonStyles_1.default.filled;
    }
    else if (!fill && disabled) {
        color = colors_1.default.FONT_GRAY;
        backgroundStyle = buttonStyles_1.default.disbledNotFilled;
    }
    else {
        color = colors_1.default.BLUE;
        backgroundStyle = buttonStyles_1.default.notFilled;
    }
    const pressableStyle = [
        buttonStyles_1.default.notFilled,
        styles_1.default.flexDirectionRow,
        styles_1.default.alignCenterCenter,
        styles_1.default.button,
        backgroundStyle,
    ];
    return (react_1.default.createElement(react_native_1.View, null,
        react_1.default.createElement(pressable_1.default, { onPress: onPress, style: pressableStyle, eventName: eventName, disabled: disabled },
            icon ? react_1.default.createElement(icon_1.default, { icon: icon, color: color }) : null,
            react_1.default.createElement(react_native_paper_1.Title, { style: [styles_1.default.textColorWhite, styles_1.default.marginTen, styles_1.default.fontSizeText, { color }] }, text))));
};
Button.defaultProps = DefaultProps;
exports.default = Button;
